export default __webpack_public_path__ + "static/media/nossa_localizacao.8e8288bf.jpg";